import { render, staticRenderFns } from "./PlantModal.vue?vue&type=template&id=3814e06e"
import script from "./PlantModal.vue?vue&type=script&lang=js"
export * from "./PlantModal.vue?vue&type=script&lang=js"
import style0 from "./PlantModal.vue?vue&type=style&index=0&id=3814e06e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports